import { Flex } from '@chakra-ui/react'
interface IProps {
	children: React.ReactNode
}

const AppContainer: React.FC<IProps> = ({ children }) => {
	return (
		<Flex
			bg="#B4B4B8"
			position="relative"
			flexDir={'column'}
			justify="flex-end"
			width="100vw"
			height="100vh"
		>
			{children}
		</Flex>
	)
}

export default AppContainer
